import { useContext } from "react";
import AirlineSection from "./components/AirlineSection";
import Banner from "./components/Banner";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import SecuringSection from "./components/SecuringSection";
import TeasersSection from "./components/TeasersSection";
import { Context } from "./ContextProvider";
import { LANGUAGE } from "./type";

function App() {
  const { language } = useContext(Context);

  return (
    <div className="App">
      <Header />
      <SecuringSection />
      <TeasersSection />
      <AirlineSection />
      <ContactSection />
      {language === LANGUAGE.FR && <Banner />}
      <Footer />
    </div>
  );
}

export default App;
